<script lang="ts">
  /**
   * YourStrokesSection — "Your strokes · per 25" on the Strokes tab (owner's
   * ask 2026-09-01: stroke insights with trends, best 25s, strokes per 25).
   * One card per stroke swum, IM order. What the numbers mean lives in each
   * card's "How it's counted" tap, not in a section explainer (steering round
   * 3, 2026-09-11: no sentence above the cards).
   *
   * Coverage honesty: the rows come from the swimFacts v3 cache. While the
   * background scan is still backfilling v1/v2 carry-overs, the section
   * labels itself "Counted from N of M swims so far." — never an all-time
   * claim.
   */
  import type { StrokeInsightRow } from "../lib/strokeInsights";
  import type { FactsCoverage } from "../lib/allTimeAggregates";
  import YourStrokesCard from "./YourStrokesCard.svelte";

  interface Props {
    rows: StrokeInsightRow[];
    coverage: FactsCoverage;
  }
  let { rows, coverage }: Props = $props();
</script>

<section class="your-strokes" aria-label="Your strokes">
  <h2 class="sec-label">Your strokes · per 25</h2>

  {#if rows.length === 0}
    <div class="empty-card">
      <p class="empty-copy">Swim a few 25 m lengths and each stroke shows up here.</p>
    </div>
  {:else}
    {#each rows as row (row.stroke)}
      <YourStrokesCard {row} />
    {/each}
  {/if}

  {#if !coverage.complete}
    <p class="coverage-note">Counted from {coverage.counted} of {coverage.total} swims so far.</p>
  {/if}
</section>

<style>
  .your-strokes {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
  /* Same section-label tier as the rest of the Scores tab. */
  .sec-label {
    font: var(--type-title-card);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--text-muted);
    margin: var(--space-2) 2px calc(-1 * var(--space-1));
  }

  .empty-card {
    background: var(--bg-card);
    border: 1px solid var(--divider);
    border-radius: var(--radius-card);
    padding: var(--space-4);
  }
  .empty-copy {
    margin: 0;
    font-size: 15px;
    line-height: 1.45;
    color: var(--text-muted);
  }

  .coverage-note {
    font-size: 14px;
    color: var(--text-muted);
    margin: calc(-1 * var(--space-1)) 2px 0;
    line-height: 1.35;
  }
</style>
